import { getSearchResults } from "@pm2/api";
import { type PM2ConfigStore } from "@pm2/store";

export async function renderSearchPage(
  configStore: PM2ConfigStore,
  query: string,
) {
  const configState = configStore.getState();

  // fetch initial search results, so they are instantly available when
  // rendering the search page
  const searchPromise = getSearchResults(configState.config.id, query, {
    previewMode: configState.previewMode,
    retainOnError: true,
  });

  const [{ SearchPage }] = await Promise.all([
    import("@pm2/search"),
    searchPromise instanceof Promise
      ? searchPromise.catch((err) => console.warn(err))
      : undefined,
  ]);

  return <SearchPage initialQuery={query} />;
}
